import React from 'react';
import { SubscriptionRequiredModal as View } from './View';
import { SubscriptionRequiredModalProps } from './types';

const Main = (props: SubscriptionRequiredModalProps) => {
    return <View {...props} />;
};

export default Main;
